import { HttpClient } from "@angular/common/http";
import { Component, createPlatform, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { KitService } from "src/shared/kit.service";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FavieTranslateService } from "src/shared/translate/servives/favie-translate.service";
import { Location } from "@angular/common";
import { LocalSpinnerService } from "src/shared/components/local-spinner/local-spinner.service";
import { from } from "rxjs";
import { BaseComponent } from "src/shared/components/base-component/base.component";
@Component({
  selector: "app-contact-info",
  templateUrl: "./contact-info.component.html",
  styleUrls: ["./contact-info.component.scss"],
})
export class ContactInfoComponent extends BaseComponent {
  angForm: FormGroup;
  type: string;
  jerseyImage;
  shortImage;
  socksImage;
  currentDate = new Date();
  kitJson;
  logoImage;
  SUBMIT_SPINNER_ID = "spinner";
  image;
  uploadedImages;
  noNumber;
  noName;
  preorderId;
  shirtColor;
  shortColor;

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    private route: ActivatedRoute,
    public kitService: KitService,
    private http: HttpClient,
    public readonly translationService: FavieTranslateService,
    private location: Location,
    private readonly localSpinnerService: LocalSpinnerService,
  ) {
    super();
    this.createForm();
  }

  ngOnInit(): void {
    this.route.params.subscribe(
      (params: Params) => (this.type = params["type"])
    );
    this.kitJson = this.kitService.getJson();
    this.jerseyImage = this.kitService.getJersey();
    this.shirtColor = this.jerseyImage.couleur_fond.match(/[A-Z][a-z]+|[0-9]+/g).join(" ")
    const short = this.kitService.getShort();
    this.shortColor = short ? short.couleur.match(/[A-Z][a-z]+|[0-9]+/g).join(" ") : ''

    this.shortImage = this.kitService.getShort();
    this.socksImage = this.kitService.getSocks();
    this.logoImage = this.kitService.getJerseyImages();
    this.translationService.getLanguage()
    this.image = this.kitService.getJerseyImages();
    this.preorderId = "QT" + Math.floor(100000 + Math.random() * 900000)
    if (!this.image) {
      this.image = {
        heartImage: "",
        frontImage: "",
        leftImage: "",
        rightImage: "",
        backImage: "",
      };
    }
    var filteredImages = Object.assign(
      {},
      ...Object.entries(this.image)
        .filter(([k, v]) => v != "" && k != "shortImage")
        .map(([k, v]) => ({ [this.translationService.instant(k.replace('Image', ''))]: v }))
    );
    if (filteredImages) {
      this.uploadedImages = Object.keys(filteredImages).join(", ");
    }

    this.noNumber = "Non";
    if (this.kitService.isNoNumber()) {
      this.noNumber = "Oui";
    }

    this.noName = "Non";
    if (this.kitService.isNoName()) {
      this.noName = "Oui";
    }
  }

  createForm() {
    this.angForm = this.fb.group({
      name: [
        "",
        {
          updateOn: 'blur',
          validators: [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(50),
          ]
        }
      ],
      email: [
        "",
        {
          updateOn: 'blur',
          validators: [
            Validators.required,
            Validators.email,
            Validators.minLength(3),
            Validators.maxLength(320),
          ],
        }
      ],
      number: ["", Validators.required],
      terms: ["", Validators.requiredTrue],
    });
  }

  public submit() {
    this.savePreorder();
  }

  onDestroy() {
    this.localSpinnerService.destroyComponent(this.SUBMIT_SPINNER_ID);
  }

  private savePreorder() {
    window.scrollTo(0, 0);
    const element = document.getElementById("pdfTable");
    const operation = html2canvas(element, {
      scrollX: 0,
      scrollY: -window.scrollY,
      scale: 2,
      allowTaint: true,
      useCORS: true,
    }).then((canvas) => {
      const fileWidth = 208;
      const fileHeight = (canvas.height * fileWidth) / canvas.width;

      const FILEURI = canvas.toDataURL("image/png");
      let PDF = new jsPDF("p", "mm", "a4");
      let position = 1;
      PDF.addImage(FILEURI, "PNG", 1, position, fileWidth - 1, fileHeight);
      const input = this.kitService.getJson();
      input["contactName"] = this.angForm.value.name;
      input["contactEmail"] = this.angForm.value.email;
      input["contactPhone"] = this.angForm.value.number;
      input["language"] = this.translationService.getLanguage();
      const formData = new FormData();
      formData.append("data", JSON.stringify(input));
      formData.append("pdf", PDF.output("blob"));
      this.http.post("https://api.myalke.fr/" + this.type, formData).subscribe(
        (data) => this.router.navigate(["success"]),
        (error) => this.router.navigate(["failure"])
      );
    });
    this.localSpinnerService.withLocalSpinner(
      from(operation),
      this.SUBMIT_SPINNER_ID
    );
  }

  public back() {
    this.location.back();
  }
}
